import React, { useContext, useCallback, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { FaChevronLeft } from 'react-icons/fa'
import urls from '../../../../utils/constants/urls'
import { useLocation } from 'react-router-dom'

import { DataContext } from '../DataContext'

export default () => {
    const { returnToList, submissionState } = useContext(DataContext)
    const location = useLocation()
    const history = useHistory()

    const onClick = useCallback(() => {
        returnToList()
            .then(() => {
                history.push(urls.manageSampleResults)
            })
            .catch(() => {
            })
    }, [returnToList])

    const gsaID = useMemo(() => {
        if (submissionState && submissionState.facility && submissionState.facility.facilityName) {
            return submissionState.facility.facilityName
        }
        if (location.state && location.state.GSAID) {
            return location.state.GSAID
        }
        return ''
    }, [submissionState, location])
    
    return (
        <nav
            className="breadcrumb breadcrumbAlignment"
            aria-label="breadcrumbs"
        >
            <ul>
                <li>
                    <div className="link"
                        onClick={onClick}
                    >
                        <span className="icon is-small">
                            <FaChevronLeft />
                        </span>
                        <span>Return to Submissions List</span>
                    </div>
                </li>
            </ul>
            <div className='clearinghouseNumber'>
                {submissionState && submissionState.facility && submissionState.facility.facilityName
                    ? <span>
                        <b>GSA ID:</b> { gsaID }
                    </span>
                    : <span></span>
                }
            </div>
        </nav>
    )
}
